var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { BannerV2Format } from '@square/dashboard-protos/models/squareup/messageservice/service';
import Service, { inject as service } from '@ember/service';
import { open } from '@square/dashboard-utilities/utils/window';
let TransferOutageBannerService = (_class = class TransferOutageBannerService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "logEvents", _descriptor, this);
  }
  getBanners(messageUnits) {
    const banners = [];
    if (messageUnits && messageUnits.length > 0) {
      const banner = this.createTransferOutageBanner(messageUnits);
      if (banner) {
        banners.push(banner);
      }
    }
    return banners;
  }
  createTransferOutageBanner(messageUnits) {
    const currentMessage = messageUnits?.[0];
    const banner = currentMessage?.bannerV2Format;
    if (!banner) {
      return null;
    }
    const actions = [];
    if (banner.primaryLinkText && banner.primaryLinkWebUrl) {
      actions.push({
        elementType: 'button',
        text: banner.primaryLinkText,
        onClick: () => this.handlePrimaryAction(banner)
      });
    }
    return {
      key: 'transfer-outage-banner',
      variant: this.getBannerVariant(banner.type),
      title: banner.title,
      description: banner.body,
      actions: actions.length > 0 ? actions : undefined
    };
  }
  getBannerVariant(type) {
    switch (type) {
      case BannerV2Format.BannerV2Type.BANNER_V2_TYPE_CRITICAL:
        return 'critical';
      case BannerV2Format.BannerV2Type.BANNER_V2_TYPE_INFO:
        return 'info';
      case BannerV2Format.BannerV2Type.BANNER_V2_TYPE_WARNING:
      default:
        return 'warning';
    }
  }
  handlePrimaryAction(banner) {
    if (banner.primaryLinkWebUrl) {
      open(banner.primaryLinkWebUrl, '_blank', 'noopener noreferrer');
    }
    if (banner.primaryClickLogEvent) {
      this.logEvents.track(banner.primaryClickLogEvent, banner.primaryClickLogEvent?.dynamicProperties);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TransferOutageBannerService as default };